














































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import CarrierContactsSearchRequest from '@/models/requests/CarrierContactsSearchRequest';
import { CarrierContactLookup } from '@/models/carriers/CarrierContactLookup';
import { Account } from '@/models/Account';

import carrierService from '@/services/CarrierService';
import miscService from '@/services/MiscService';
import localStorageService from '@/services/LocalStorageService';
import accountsService from '@/services/AccountsService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      loading: false,
      editing: false,
      showFilters: false,
      displayEditContactPopup: false,
      displayAddContactPopup: false,
      snackbar: false,
      showPaging: false,
      snackbarText: '',
      displayConfirmDelete: false,
      deleting: false,
      currentContactId: null,
    };
  },
  created() {
    this.fetch();

    accountsService.getAllAccounts().then((x: Account[]) => {
      this.$store.commit('carrierContacts/setAccounts', x);
    });
  },
  methods: {
    backToPrevPage() {
      miscService.goBack();
    },
    fetch() {
      this.loading = true;
      carrierService
        .getCarrierContacts(this.currentCarrier.carrierId)
        .then((x: CarrierContactLookup[]) => {
          this.$store.commit('carrierContacts/setContacts', x);
          this.$store.commit(
            'carrierContacts/setFilter',
            new CarrierContactsSearchRequest()
          );

          this.applyFilters();
          this.loading = false;
        });
    },
    applyFilters() {
      let items = this.all;

      if (this.searchFilter.name) {
        items = items.filter((x) =>
          x.contactName
            .toLowerCase()
            .includes(this.searchFilter.name.toLowerCase())
        );
      }

      if (this.searchFilter.email) {
        items = items.filter((x) =>
          x.email.toLowerCase().includes(this.searchFilter.email.toLowerCase())
        );
      }

      if (this.searchFilter.departmentName) {
        items = items.filter((x) =>
          x.departmentName
            .toLowerCase()
            .includes(this.searchFilter.departmentName.toLowerCase())
        );
      }

      if (this.searchFilter.accountName) {
        items = items.filter((x) =>
          x.accountName
            ?.toLowerCase()
            .includes(this.searchFilter.accountName.toLowerCase())
        );
      }

      if (this.searchFilter.userName) {
        items = items.filter((x) =>
          x.userName
            ?.toLowerCase()
            .includes(this.searchFilter.userName.toLowerCase())
        );
      }

      this.$store.commit('carrierContacts/setFilteredContacts', items);

      const page = items.slice(0, this.pageSize);
      this.$store.commit('carrierContacts/setPage', page);
    },
    showHideFilters() {
      this.showFilters = !this.showFilters;
    },
    showEditDialog(carrier) {
      this.$store.commit('carrierContacts/setContactToEdit', carrier);
      this.displayEditContactPopup = true;
    },
    resetFilter() {
      this.$store.commit('carrierContacts/resetFilter');
      this.applyFilters();
    },
    pageChange(newPage) {
      let page = this.filteredContacts.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.$store.commit('carrierContacts/setPage', page);
    },
    confirmDelete(id) {
      this.displayConfirmDelete = true;
      this.currentContactId = id;
    },
    softDeleteCarrier() {
      this.deleting = true;
      carrierService
        .deleteCarrierContact(
          this.currentCarrier.carrierId,
          this.currentContactId
        )
        .then(() => {
          this.deleting = false;
          this.displayConfirmDelete = false;
          this.snackbarText = 'Carrier contact deleted.';
          this.snackbar = true;
          this.fetch();
        });
    },
    onAddContactPopupClose() {
      this.$store.commit('carrierContacts/setContactToEdit');
    },
    carrierContactSaved() {
      this.snackbarText = 'Carrier contact saved.';
      this.snackbar = true;

      this.resetFilter();
    },
    openNewContactPopup() {
      this.$store.commit('carrierContacts/setContactToEdit');
      this.displayAddContactPopup = true;
    },
  },
  computed: {
    ...mapGetters('carrierContacts', [
      'all',
      'page',
      'filteredContacts',
      'searchFilter',
    ]),
    pagingLength() {
      return Math.ceil(this.filteredContacts.length / this.pageSize);
    },
    currentCarrier() {
      return localStorageService.get('selected-admin-carrier');
    },
    filtersWidth() {
      if (this.lg || this.xl) return '60%';

      if (this.md) return '75%';

      return '90%';
    },
    backToLbl() {
      return document.referrer?.includes('/dashboard')
        ? 'Back to Dashboard'
        : 'Back to Carriers';
    },
  },
});
